<template>
  <v-flex shrink>
    <ProjectMainCard :project="project" :recordCache="recordCache" />
  </v-flex>
</template>
<script>
import ProjectMainCard from "@/components/ProjectMainCard";
import { Record } from "@/classes/Record/Record";
import { Project } from "@/classes/Project/Project";
import { RecordCache } from "@/classes/RecordCache/RecordCache";
export default {
  components: { ProjectMainCard },
  mounted() {
    this.project.updateData(this.project1);
    setInterval(() => {
      if (this.project.percentage > 1) {
        this.project.updateData(this.rotateData());
        this.recordCache = new RecordCache("");
        return;
      }
      let r = new Record("");
      let value = 0;
      if (this.project.isDuration()) {
        let target = this.project.target;
        value = Math.ceil(Math.random() * target);
      } else {
        value = 1;
      }
      r.updateData({ value, type: this.project.type });
      this.recordCacheOverwriteAddRecord(r);
      this.project.addRecord(r);
    }, 4000);
  },
  methods: {
    rotateData() {
      this.dataIndex += 1;
      if (this.dataIndex > this.projectData.length - 1) {
        this.dataIndex = 0;
      }
      return this.projectData[this.dataIndex];
    },
    recordCacheOverwriteAddRecord(record) {
      let rc = new RecordCache("");
      rc.updateData(this.recordCache.data);
      rc.addRecord(record);
      this.recordCache = rc;
    }
  },
  data() {
    // BLUE 3F51B5
    // Orange #F57F17"
    // light blue
    let pData1 = {
      name: "Judo",
      description: "Practice one hand shoulder throw at least 2 hours per day.",
      timePeriod: Project.timePeriod.day,
      operator: Project.operator.more,
      type: Project.type.duration,
      target: 2 * 60 * 60000,
      color: "#1E88E5",
      current: 0
    };
    let pData2 = {
      name: "Soda",
      description: "Drink no more than one can per week.",
      color: "#F57F17",
      type: Project.type.counter,
      operator: Project.operator.less,
      target: 1,
      current: 0
    };
    let pData3 = {
      name: "Claymore",
      description: "Refine swordsmanship least 20 hours per week.",
      timePeriod: Project.timePeriod.week,
      operator: Project.operator.more,
      type: Project.type.duration,
      target: 20 * 60 * 60000,
      color: "#FF0033",
      current: 0
    };
    let pData4 = {
      name: "Javascript",
      description: "Use the good parts at least 40 hours per week.",
      timePeriod: Project.timePeriod.week,
      operator: Project.operator.more,
      type: Project.type.duration,
      target: 40 * 60 * 60000,
      color: "#7986CB",
      current: 0
    };
    let p = new Project("");
    p.updateData(pData1);
    return {
      project: p,
      recordCache: new RecordCache(""),
      projectData: [pData1, pData2, pData3, pData4],
      dataIndex: 0
    };
  }
};
</script>
